import http from '@/service/http'
import findIndex from 'lodash/findIndex'

const save = async (context, obj) => {
  const { verb, perfil } = obj
  const response = await http[verb]('/perfil', perfil)

  if (response !== null) {
    perfil.id = response.data.data.id
    update(context, { ...perfil })
    return Promise.resolve()
  }
}

const fetchOne = async (context, id) => {
  const response = await http.get(`/perfil/${id}`)
  if (response !== null) {
    return Promise.resolve(response.data.data)
  }
}

const fetch = async ({ commit }) => {
  const response = await http.get('/perfil')
  if (response !== null) {
    const perfis = response.data
    commit('SET_LIST', perfis)
  }
}

const update = ({ commit, state }, obj) => {
  const index = findIndex(state.list, { id: obj.id })
  const payload = { perfil: obj, index }
  commit('SET_ONE', payload)
}

const remove = ({ commit, state }, obj) => {
  return new Promise(async (resolve) => {
    const { id } = obj
    const response = await http.delete(`/perfil/${id}`)
    const message = response.data.data
    const index = findIndex(state.list, { id })

    if (index > -1) {
      commit('REMOVE_ONE', { index })
    }

    resolve(message)
  })
}

export default {
  fetch,
  fetchOne,
  save,
  update,
  remove
}



// WEBPACK FOOTER //
// ./src/features/admin/perfis/store/actions.js